import { useEffect } from 'react'

interface useModalOverflowHiddenProps {
  open: boolean
}

export const useModalOverflowHidden = ({
  open
}: useModalOverflowHiddenProps) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add('overflow-hidden')
    }
    return () => document.body.classList.remove('overflow-hidden')
  }, [open])
}
